var map = {
	"./CanadaFlag.svg": 96609,
	"./addHome.svg": 80131,
	"./addVideo.svg": 34799,
	"./addVideo2.svg": 72127,
	"./addVideo3.svg": 57486,
	"./appleShare.svg": 45972,
	"./arrowDown.svg": 58372,
	"./back.svg": 11884,
	"./bell.svg": 89038,
	"./bellFilled.svg": 76810,
	"./camera.svg": 48900,
	"./checkmark.svg": 92576,
	"./clock.svg": 11029,
	"./close.svg": 26419,
	"./comment.svg": 31556,
	"./edit.svg": 39053,
	"./editProfile.svg": 55760,
	"./error.svg": 54409,
	"./eyeClosed.svg": 78764,
	"./facebook.svg": 95645,
	"./flags/ad.svg": 34982,
	"./flags/ae.svg": 49367,
	"./flags/af.svg": 6244,
	"./flags/ag.svg": 57413,
	"./flags/ai.svg": 17939,
	"./flags/al.svg": 34638,
	"./flags/am.svg": 63071,
	"./flags/ao.svg": 82989,
	"./flags/aq.svg": 5595,
	"./flags/ar.svg": 54856,
	"./flags/arab.svg": 84201,
	"./flags/as.svg": 36601,
	"./flags/at.svg": 80214,
	"./flags/au.svg": 44039,
	"./flags/aw.svg": 52085,
	"./flags/ax.svg": 97970,
	"./flags/az.svg": 55568,
	"./flags/ba.svg": 48574,
	"./flags/bb.svg": 94845,
	"./flags/bd.svg": 64227,
	"./flags/be.svg": 60914,
	"./flags/bf.svg": 65953,
	"./flags/bg.svg": 74832,
	"./flags/bh.svg": 55399,
	"./flags/bi.svg": 8534,
	"./flags/bj.svg": 28821,
	"./flags/bl.svg": 68539,
	"./flags/bm.svg": 99722,
	"./flags/bn.svg": 49017,
	"./flags/bo.svg": 53000,
	"./flags/bq.svg": 53902,
	"./flags/br.svg": 36877,
	"./flags/bs.svg": 89516,
	"./flags/bt.svg": 12083,
	"./flags/bv.svg": 65457,
	"./flags/bw.svg": 51072,
	"./flags/by.svg": 97926,
	"./flags/bz.svg": 46053,
	"./flags/ca.svg": 89293,
	"./flags/cc.svg": 20959,
	"./flags/cd.svg": 3488,
	"./flags/cefta.svg": 70016,
	"./flags/cf.svg": 60770,
	"./flags/cg.svg": 64499,
	"./flags/ch.svg": 1220,
	"./flags/ci.svg": 98469,
	"./flags/ck.svg": 55671,
	"./flags/cl.svg": 10744,
	"./flags/cm.svg": 36105,
	"./flags/cn.svg": 74938,
	"./flags/co.svg": 68811,
	"./flags/cp.svg": 18716,
	"./flags/cr.svg": 990,
	"./flags/cu.svg": 18369,
	"./flags/cv.svg": 13330,
	"./flags/cw.svg": 16643,
	"./flags/cx.svg": 59604,
	"./flags/cy.svg": 81237,
	"./flags/cz.svg": 60950,
	"./flags/de.svg": 95900,
	"./flags/dg.svg": 12350,
	"./flags/dj.svg": 63515,
	"./flags/dk.svg": 29322,
	"./flags/dm.svg": 14100,
	"./flags/do.svg": 98486,
	"./flags/dz.svg": 68843,
	"./flags/eac.svg": 5318,
	"./flags/ec.svg": 82293,
	"./flags/ee.svg": 52635,
	"./flags/eg.svg": 53017,
	"./flags/eh.svg": 66846,
	"./flags/er.svg": 9604,
	"./flags/es-ct.svg": 4403,
	"./flags/es-ga.svg": 97434,
	"./flags/es-pv.svg": 25348,
	"./flags/es.svg": 87621,
	"./flags/et.svg": 52698,
	"./flags/eu.svg": 57963,
	"./flags/fi.svg": 37922,
	"./flags/fj.svg": 1969,
	"./flags/fk.svg": 61408,
	"./flags/fm.svg": 36494,
	"./flags/fo.svg": 95404,
	"./flags/fr.svg": 5433,
	"./flags/ga.svg": 93849,
	"./flags/gb-eng.svg": 98313,
	"./flags/gb-nir.svg": 77934,
	"./flags/gb-sct.svg": 42435,
	"./flags/gb-wls.svg": 53585,
	"./flags/gb.svg": 2474,
	"./flags/gd.svg": 36724,
	"./flags/ge.svg": 9333,
	"./flags/gf.svg": 37462,
	"./flags/gg.svg": 1287,
	"./flags/gh.svg": 12816,
	"./flags/gi.svg": 48353,
	"./flags/gl.svg": 99676,
	"./flags/gm.svg": 89149,
	"./flags/gn.svg": 34974,
	"./flags/gp.svg": 17432,
	"./flags/gq.svg": 21673,
	"./flags/gr.svg": 53562,
	"./flags/gs.svg": 68171,
	"./flags/gt.svg": 63492,
	"./flags/gu.svg": 14661,
	"./flags/gw.svg": 6615,
	"./flags/gy.svg": 90385,
	"./flags/hk.svg": 44646,
	"./flags/hm.svg": 69848,
	"./flags/hn.svg": 20587,
	"./flags/hr.svg": 31119,
	"./flags/ht.svg": 769,
	"./flags/hu.svg": 65232,
	"./flags/ic.svg": 75617,
	"./flags/id.svg": 58238,
	"./flags/ie.svg": 78287,
	"./flags/il.svg": 18198,
	"./flags/im.svg": 65063,
	"./flags/in.svg": 16852,
	"./flags/io.svg": 38485,
	"./flags/iq.svg": 21747,
	"./flags/ir.svg": 60736,
	"./flags/is.svg": 75121,
	"./flags/it.svg": 63566,
	"./flags/je.svg": 86570,
	"./flags/jm.svg": 89842,
	"./flags/jo.svg": 66288,
	"./flags/jp.svg": 90711,
	"./flags/ke.svg": 74537,
	"./flags/kg.svg": 78507,
	"./flags/kh.svg": 70860,
	"./flags/ki.svg": 50573,
	"./flags/km.svg": 30449,
	"./flags/kn.svg": 75906,
	"./flags/kp.svg": 23764,
	"./flags/kr.svg": 8150,
	"./flags/kw.svg": 73179,
	"./flags/ky.svg": 76189,
	"./flags/kz.svg": 22014,
	"./flags/la.svg": 80936,
	"./flags/lb.svg": 62299,
	"./flags/lc.svg": 36682,
	"./flags/li.svg": 37968,
	"./flags/lk.svg": 54674,
	"./flags/lr.svg": 67627,
	"./flags/ls.svg": 62362,
	"./flags/lt.svg": 97285,
	"./flags/lu.svg": 19268,
	"./flags/lv.svg": 23863,
	"./flags/ly.svg": 18656,
	"./flags/ma.svg": 84095,
	"./flags/mc.svg": 56877,
	"./flags/md.svg": 47586,
	"./flags/me.svg": 61811,
	"./flags/mf.svg": 71072,
	"./flags/mg.svg": 11633,
	"./flags/mh.svg": 13478,
	"./flags/mk.svg": 49701,
	"./flags/ml.svg": 14778,
	"./flags/mm.svg": 36395,
	"./flags/mn.svg": 81208,
	"./flags/mo.svg": 56713,
	"./flags/mp.svg": 28926,
	"./flags/mq.svg": 7855,
	"./flags/mr.svg": 28828,
	"./flags/ms.svg": 57373,
	"./flags/mt.svg": 7090,
	"./flags/mu.svg": 56483,
	"./flags/mv.svg": 90384,
	"./flags/mw.svg": 88833,
	"./flags/mx.svg": 31414,
	"./flags/my.svg": 70951,
	"./flags/mz.svg": 99444,
	"./flags/na.svg": 64882,
	"./flags/nc.svg": 22480,
	"./flags/ne.svg": 44638,
	"./flags/nf.svg": 98813,
	"./flags/ng.svg": 9340,
	"./flags/ni.svg": 12138,
	"./flags/nl.svg": 10951,
	"./flags/no.svg": 46388,
	"./flags/np.svg": 84851,
	"./flags/nr.svg": 49,
	"./flags/nu.svg": 1550,
	"./flags/nz.svg": 31337,
	"./flags/om.svg": 76741,
	"./flags/pa.svg": 30116,
	"./flags/pc.svg": 85702,
	"./flags/pe.svg": 37080,
	"./flags/pf.svg": 92267,
	"./flags/pg.svg": 73210,
	"./flags/ph.svg": 64333,
	"./flags/pk.svg": 35214,
	"./flags/pl.svg": 44209,
	"./flags/pm.svg": 97760,
	"./flags/pn.svg": 68659,
	"./flags/pr.svg": 25383,
	"./flags/ps.svg": 38262,
	"./flags/pt.svg": 13497,
	"./flags/pw.svg": 52746,
	"./flags/py.svg": 19324,
	"./flags/qa.svg": 76059,
	"./flags/re.svg": 61346,
	"./flags/ro.svg": 94968,
	"./flags/rs.svg": 42588,
	"./flags/ru.svg": 37202,
	"./flags/rw.svg": 4144,
	"./flags/sa.svg": 12573,
	"./flags/sb.svg": 58398,
	"./flags/sc.svg": 2127,
	"./flags/sd.svg": 36240,
	"./flags/se.svg": 71777,
	"./flags/sg.svg": 93283,
	"./flags/sh-ac.svg": 87749,
	"./flags/sh-hl.svg": 76909,
	"./flags/sh-ta.svg": 436,
	"./flags/sh.svg": 76500,
	"./flags/si.svg": 32757,
	"./flags/sj.svg": 60886,
	"./flags/sk.svg": 24711,
	"./flags/sl.svg": 35528,
	"./flags/sm.svg": 17273,
	"./flags/sn.svg": 25898,
	"./flags/so.svg": 86267,
	"./flags/sr.svg": 15310,
	"./flags/ss.svg": 43743,
	"./flags/st.svg": 77856,
	"./flags/sv.svg": 93442,
	"./flags/sx.svg": 86916,
	"./flags/sy.svg": 38085,
	"./flags/sz.svg": 15654,
	"./flags/tc.svg": 45858,
	"./flags/td.svg": 16077,
	"./flags/tf.svg": 96159,
	"./flags/tg.svg": 67726,
	"./flags/th.svg": 97513,
	"./flags/tj.svg": 44011,
	"./flags/tk.svg": 29402,
	"./flags/tl.svg": 90501,
	"./flags/tm.svg": 39332,
	"./flags/tn.svg": 82455,
	"./flags/to.svg": 68070,
	"./flags/tr.svg": 45699,
	"./flags/tt.svg": 64989,
	"./flags/tv.svg": 54543,
	"./flags/tw.svg": 10814,
	"./flags/tz.svg": 38683,
	"./flags/ua.svg": 36343,
	"./flags/ug.svg": 16777,
	"./flags/um.svg": 45171,
	"./flags/un.svg": 84160,
	"./flags/us.svg": 61909,
	"./flags/uy.svg": 1711,
	"./flags/uz.svg": 99388,
	"./flags/va.svg": 9994,
	"./flags/vc.svg": 62824,
	"./flags/ve.svg": 79158,
	"./flags/vg.svg": 94772,
	"./flags/vi.svg": 13266,
	"./flags/vn.svg": 47197,
	"./flags/vu.svg": 42950,
	"./flags/wf.svg": 95366,
	"./flags/ws.svg": 96603,
	"./flags/xk.svg": 2422,
	"./flags/xx.svg": 20709,
	"./flags/ye.svg": 7519,
	"./flags/yt.svg": 52350,
	"./flags/za.svg": 25318,
	"./flags/zm.svg": 3106,
	"./flags/zw.svg": 45192,
	"./flame.svg": 88218,
	"./google.svg": 42724,
	"./heart.svg": 18139,
	"./heartFilled.svg": 89351,
	"./home.svg": 92368,
	"./homeFilled.svg": 77128,
	"./inactiveTimer.svg": 1353,
	"./info.svg": 96261,
	"./leaderboard.svg": 62850,
	"./leaderboardNew.svg": 95760,
	"./leave.svg": 11746,
	"./letter.svg": 41445,
	"./lock.svg": 47756,
	"./loginWithGoogle.svg": 76933,
	"./marker.svg": 47483,
	"./microphone.svg": 70361,
	"./microphoneOff.svg": 10232,
	"./moreicon.svg": 27905,
	"./options.svg": 90245,
	"./optionsRounded.svg": 21996,
	"./orangeCircles.svg": 33686,
	"./pauseBtn.svg": 50163,
	"./pin.svg": 31334,
	"./playBtn.svg": 37201,
	"./playIcon.svg": 55668,
	"./post.svg": 735,
	"./question.svg": 50725,
	"./remove.svg": 11357,
	"./reportNew.svg": 12803,
	"./reports.svg": 91097,
	"./reportsFilled.svg": 7698,
	"./search.svg": 98073,
	"./searchFilled.svg": 50793,
	"./seePassword.svg": 50401,
	"./share.svg": 10070,
	"./shareNew.svg": 90980,
	"./sparkShare.svg": 52977,
	"./star.svg": 71693,
	"./starFilled.svg": 18869,
	"./success.svg": 92282,
	"./tagSearch.svg": 35255,
	"./twitter.svg": 49562,
	"./video.svg": 34106,
	"./videoFilled.svg": 79470,
	"./warning.svg": 56063,
	"./whiteHeart.svg": 6160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16830;